import { Box } from '@web/components/atoms/Layout'
import { Image } from '@web/components/atoms/Image'

export const BADGE_DEFAULT_WIDTH = 96
export const BADGE_MIN_WIDTH = 24
export const BADGE_MAX_WIDTH = 200
export const BADGE_ALT_FALLBACK = 'Accreditation'

export type FooterBadgeStyles = {
  badgeUrl?: string
  badgeHref?: string
  badgeTarget?: string
  badgeAlt?: string
  badgeWidth?: string
}

type FooterBadgeProps = {
  styles?: FooterBadgeStyles
  disableLink?: boolean
}

export const resolveBadgeWidth = (badgeWidth?: string) => {
  const parsed = Number.parseInt(String(badgeWidth ?? '').replace('px', ''), 10)

  if (!Number.isFinite(parsed)) {
    return BADGE_DEFAULT_WIDTH
  }

  return Math.min(BADGE_MAX_WIDTH, Math.max(BADGE_MIN_WIDTH, parsed))
}

const FooterBadge = ({ styles, disableLink = false }: FooterBadgeProps) => {
  const url = styles?.badgeUrl

  if (!url) {
    return null
  }

  const alt = styles.badgeAlt?.trim() || BADGE_ALT_FALLBACK
  const href = disableLink ? undefined : styles.badgeHref
  const target = styles.badgeTarget || '_blank'
  const width = `${resolveBadgeWidth(styles.badgeWidth)}px`

  return (
    <Box
      flexShrink={0}
      w={width}
      {...(href
        ? {
            as: 'a' as const,
            href,
            target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined,
          }
        : {})}
    >
      <Image src={url} alt={alt} draggable={false} w="100%" h="auto" objectFit="contain" />
    </Box>
  )
}

export default FooterBadge
